import { organizationEntityName, } from '../../../../../backend/features/organizations/shared';
import { DataTree } from '@juvare/common-data-table-ui/DataTree';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { LayoutColumns2 } from '@juvare/common-web-ui/LayoutColumns2';
import { ModalSlideout, ModalSlideoutContent, ModalSlideoutHeader, ModalSlideoutTitleArea, ModalSlideoutTopBar, ModalSlideoutTopBarDefaultActions, } from '@juvare/common-web-ui/ModalSlideout';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { OrganizationTreeInfo } from './components/OrganizationTreeInfo';
export const OrganizationTreeWithDetails = ({ dataTreeProps, filtersBar, activeOrganizationId, multiSelect, }) => {
    const theme = useTheme();
    const [infoSlideOutOpen, setInfoSlideOutOpen] = React.useState(false);
    const orgId = !!activeOrganizationId && activeOrganizationId !== 'root' ? activeOrganizationId : undefined;
    const { data, isLoading } = useStorageGet(organizationEntityName, orgId);
    const downSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    React.useEffect(() => {
        if (!isLoading && activeOrganizationId) {
            setInfoSlideOutOpen(true);
        }
    }, [isLoading, activeOrganizationId]);
    const handleCloseSlideout = () => {
        setInfoSlideOutOpen(false);
    };
    if (downSmScreen) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    height: '100%',
                    overflow: 'auto',
                } },
                React.createElement(DataTree, Object.assign({}, dataTreeProps, { filtersBar: filtersBar, getItemLabel: (item) => item.name, itemSelectionEnabled: multiSelect !== null && multiSelect !== void 0 ? multiSelect : false }))),
            !!activeOrganizationId && activeOrganizationId !== 'root' && (React.createElement(ModalSlideout, { open: infoSlideOutOpen, onClose: handleCloseSlideout, "data-test": 'organization-details-slideout' },
                React.createElement(Box, { sx: {
                        overflow: 'auto',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: themeColors.surface.primary,
                    } },
                    React.createElement(ModalSlideoutTopBar, { isOpaque: true },
                        React.createElement(ModalSlideoutTopBarDefaultActions, { onClose: handleCloseSlideout })),
                    React.createElement(Box, null,
                        React.createElement(ModalSlideoutHeader, null,
                            React.createElement(ModalSlideoutTitleArea, { titleTypographyVariant: 'h5', title: data === null || data === void 0 ? void 0 : data.data.name, subTitle: data === null || data === void 0 ? void 0 : data.data.description })),
                        React.createElement(ModalSlideoutContent, null,
                            React.createElement(Box, { sx: { p: 2 } }, activeOrganizationId && (data === null || data === void 0 ? void 0 : data.data) && (React.createElement(OrganizationTreeInfo, { id: activeOrganizationId, organization: data.data, hideHeader: true }))))))))));
    }
    return (React.createElement(LayoutColumns2, { column1: React.createElement(Box, { sx: {
                height: '100%',
                borderRight: '1px solid ' + themeColors.border,
            } },
            React.createElement(DataTree, Object.assign({}, dataTreeProps, { border: true, filtersBar: filtersBar, getItemLabel: (item) => item.name, itemSelectionEnabled: multiSelect !== null && multiSelect !== void 0 ? multiSelect : false }))), column2: React.createElement(Box, { "aria-live": 'polite', "aria-atomic": true, "aria-relevant": 'all', sx: { p: 2, height: '100%', width: '600px' } }, activeOrganizationId && (data === null || data === void 0 ? void 0 : data.data) && React.createElement(OrganizationTreeInfo, { id: activeOrganizationId, organization: data.data })), fullWidthColumn: 'column1', column2Scrollable: true, column1Scrollable: true }));
};
